<template>
  <div class="expand-card" :class="{ error }">
    <div class="expand-card__header" :class="{ opened: isExpanded || permanent }" @click="toggleExpand">
      <div>
        <div class="d-flex align-center paragraph-m_h font-600">
          {{ title }}
          <e-icon v-if="!permanent" name="chevronDown" class="expand-card__header-icon" />
        </div>

        <div v-if="slots.subtitle" class="mt-2">
          <slot name="subtitle" />
        </div>
      </div>

      <v-spacer />

      <slot v-if="slots['title-append']" name="title-append" />
    </div>
    <div v-show="isExpanded || permanent" class="expand-card__content">
      <slot />

      <div v-if="!permanent" class="d-flex mt-10">
        <e-btn variant="link" type="link" class="ml-auto" append-icon-src="chevronUp" @click="toggleExpand"
          >Свернуть</e-btn
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { EBtn, EIcon } from '@/core/components/ui';

const props = defineProps<{
  title: string;
  error?: boolean;
  permanent?: boolean;
}>();

const slots = defineSlots<{
  subtitle?: () => void;
  'title-append'?: () => void;
  default: () => void;
}>();

const isExpanded = defineModel<boolean>('expanded');

const toggleExpand = () => {
  if (props.permanent) {
    return;
  }

  isExpanded.value = !isExpanded.value;
};
</script>

<style lang="scss" scoped>
.expand-card {
  border: 1px solid $border-color-light;
  border-radius: 16px;

  &.error {
    border-color: $alert-color;

    .expand-card__header {
      background-color: $alert-bg-color;
    }
  }

  &__header {
    display: flex;
    align-items: center;

    padding: 16px 24px;

    border-radius: 16px;

    cursor: pointer;

    &.opened {
      margin-bottom: -16px;
      padding-bottom: 32px;

      background-color: $primary-light-color;
      border-radius: 16px 16px 0 0;

      .expand-card__header-icon {
        transform: rotate(180deg);
      }
    }

    &-icon {
      margin-left: 4px;

      transition: transform $transition-duration;
    }
  }

  &__content {
    padding: 24px;

    background-color: $white-color;
    border-radius: 16px;
  }
}
</style>
